export default function Support() {
	return (
		<div className="container py-12">
			<h1 className="text-3xl font-bold">Support</h1>
			<p className="mt-4 text-gray-600">Contact support@ubiquityglass.com for assistance. Lifetime workmanship warranty included.</p>
		</div>
	);
}
